import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0dade172"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/booking-staging.greenmotion.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dade172')) {
      api.createRecord('0dade172', component.options)
    } else {
      api.reload('0dade172', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=0dade172", function () {
      api.rerender('0dade172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/scripts/apps/header/components/Header.vue"
export default component.exports